export const certificates = [
  {
    title: "Power BI Virtual Internship",
    issuer: "PwC",
    date: "January 2025",
    score: "80%",
    image: "/src/assets/certificates/pwc-powerbi.jpg",
    link: "https://www.theforage.com/virtual-internships/certificate/12345"
  },
  {
    title: "Data Analytics & Visualization",
    issuer: "Forage x Accenture",
    date: "September 2024",
    image: "/src/assets/certificates/accenture-data.jpg",
    link: "https://www.theforage.com/virtual-internships/certificate/67890"
  },
  {
    title: "Quantium Data Analytics Certification",
    issuer: "Quantium",
    date: "January 2025",
    image: "/src/assets/certificates/quantium-analytics.jpg",
    link: "https://www.theforage.com/virtual-internships/certificate/12345"
  },
  {
    title: "DSA using C++",
    issuer: "CodeHelp",
    date: "November 2024",
    image: "/src/assets/certificates/dsa-codehelp.jpg",
    link: "https://codehelp.com/certificate/dsa-12345"
  },
  {
    title: "GUVI Certification - Data Analytics",
    issuer: "HCL",
    date: "December 2024",
    image: "/src/assets/certificates/guvi-hcl.jpg",
    link: "https://www.guvi.in/verify/certificate/67890"
  },
  {
    title: "Excel Using AI",
    issuer: "OfficeMoster Workshop",
    date: "May 2024",
    image: "/src/assets/certificates/excel-ai.jpg",
    link: "https://officemaster.com/certificate/12345"
  }
];
